<template src="./BrandList.html"></template>

<script>
import Pagination from '@/components/components/pagination';
import topMenu from '@/components/brand/components/topMenu';
import {createNamespacedHelpers} from 'vuex';
import Multiselect from 'vue-multiselect';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/list')

export default {
  name: "brand",
  components: {
    Pagination,
    topMenu,
    Multiselect
  },
  data() {
    return {
      nameFilter: '',
      groupFilter: '',
      siteFilter: '',
      // brandTasksFilter: '',
      tagFilter: null,

      idSign: '',
      idFilter: '',
      ratingSign: '',
      ratingFilter: '',
      efficiencySign: '',
      efficiencyFilter: '',
      ruFrequencySign: '',
      ruFrequencyFilter: '',
      wwFrequencySign: '',
      wwFrequencyFilter: '',
      goodsNumberSign: '',
      goodsNumberFilter: '',
      pureArticlesSign: '',
      pureArticlesFilter: '',
      lastDateSign: '',
      lastDateFilter: '',

      idToSign: '',
      idToFilter: '',
      ratingToSign: '',
      ratingToFilter: '',
      efficiencyToSign: '',
      efficiencyToFilter: '',
      ruFrequencyToSign: '',
      ruFrequencyToFilter: '',
      wwFrequencyToSign: '',
      wwFrequencyToFilter: '',
      goodsNumberToSign: '',
      goodsNumberToFilter: '',
      pureArticlesToSign: '',
      pureArticlesToFilter: '',
      lastDateToSign: '',
      lastDateToFilter: '',
      showOverlay: 0,
      availableField: [],
      selectedField: {},
      activeField: [],
      tableIsShow: true,
      filterVal: [],
      rangeFields: [
        'saleId',
        'rating',
        'efficiency',
        'ruFrequency',
        'wwFrequency',
        'goodsNumber',
        'pureArticles',
        'categoryCount',
      ]
    }
  },
  methods: {
    ...mapActions([
      'FINANCE_PREPARE',
      'GET_TAGS',
      'GET_ALL',
      'FILTER_CLEAN'
    ]),
    isRange: function (colName) {
      return this.rangeFields.indexOf(colName) != -1 || colName.indexOf('_Fin') != -1;
    },
    getAvailableField: function (colName) {
      let buf = [];
      for (let key in this.availableField) {
        buf[key] = this.availableField[key];
      }
      for (let key in this.FIELD_FULL_LIST) {
        if (this.FIELD_FULL_LIST[key].key == colName) {
          buf.unshift({
            value: this.FIELD_FULL_LIST[key].key,
            text: this.FIELD_FULL_LIST[key].label
          });
          break;
        }
      }

      return buf;
    },
    updateAvailableField: function () {
      this.availableField = [];
      for (let key1 in this.FIELD_FULL_LIST) {
        let inSelected = false;
        for (let key2 in this.selectedField) {
          if (this.selectedField[key2] == this.FIELD_FULL_LIST[key1].key) {
            inSelected = true;
            break;
          }
        }
        if (!inSelected) {
          this.availableField.push({
            value: this.FIELD_FULL_LIST[key1].key,
            text: this.FIELD_FULL_LIST[key1].label,
            sortable: this.FIELD_FULL_LIST[key1].sortable
          });
        }
      }
    },
    getColNumber: function (colName) {
      for (let index in this.activeField) {
        if (colName == this.activeField[index].key) {
          return index;
        }
      }

      return false;
    },
    fieldChange: function (colNumber) {
      this.filterClean();
      this.updateActiveField(colNumber);
      this.updateAvailableField();
      // update url params
      this.updateExportURL()
    },

    updateActiveField: function (colNumber) {
      let fieldName = this.selectedField[colNumber];
      for (let key in this.availableField) {
        if (fieldName == this.availableField[key].value) {
          this.$set(this.activeField, colNumber, {
            key: this.availableField[key].value,
            label: this.availableField[key].text,
            sortable: this.availableField[key].sortable
          });
        }
      }
      // update url params
      this.updateExportURL()
    },

    updateExportURL: function () {
      let fieldLabel = {}
      for (let key in this.selectedField) {
        let label = this.getFieldName(this.selectedField[key])
        fieldLabel[this.selectedField[key]] = label
      }
      let buf = this.EXPORT_URL_FILTER
      buf = buf + '&field=' + JSON.stringify(fieldLabel)
      this.$store.commit('brand/list/SET_EXPORT_URL_FILTER', buf)
    },

    getFieldName: function (fieldKey) {
      for (let key in this.FIELD_FULL_LIST) {
        if (this.FIELD_FULL_LIST[key].key == fieldKey) {
          return this.FIELD_FULL_LIST[key].label
        }
      }

      return false
    },

    sortingChanged: function (ctx) {
      this.$store.commit('brand/list/CURRENT_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc');
      if (ctx.sortBy != this.CURRENT_SORT) {
        this.$store.commit('brand/list/CURRENT_PAGE', 1);
      }
      this.$store.commit('brand/list/CURRENT_SORT', ctx.sortBy);
      // update url params
      this.updateExportURL()
      this.GET_ALL({th: this});
    },
    nextPage: function () {
      if (this.CURRENT_PAGE < this.AMOUNT_PAGE) {
        this.$store.commit('brand/list/CURRENT_PAGE_INCREMENT');
        this.GET_ALL({th: this});
      }
    },
    prevPage: function () {
      if (this.CURRENT_PAGE > 1) {
        this.$store.commit('brand/list/CURRENT_PAGE_DECREMENT');
        this.GET_ALL({th: this});
      }
    },
    goToPage: function (page) {
      this.$store.commit('brand/list/CURRENT_PAGE', page);
      this.GET_ALL({th: this});
    },
    perPage: function (page) {
      this.$store.commit('brand/list/PAGE_SIZE', page);
      this.GET_ALL({th: this});
    },
    filterClean: function () {
      this.filterVal = [];
      this.tagFilter = null;
      this.FILTER_CLEAN();
      this.GET_ALL({th: this});
      // update url params
      this.updateExportURL()
    },
    doFilter: function (name) {
      let val = this.filterVal[name] === undefined ? false : this.filterVal[name];
      // range handle
      if (name.indexOf('Sign') != -1) {
        let filterName = name.replace('Sign', 'Filter');
        if (this.filterVal[filterName] === undefined || this.filterVal[filterName] == false) {
          return;
        } else {
          val = this.filterVal[name] + this.filterVal[filterName];
          name = name.replace('Sign', '');
        }
      }
      if (name.indexOf('Filter') != -1) {
        let singName = name.replace('Filter', 'Sign');
        if (this.filterVal[singName] !== undefined) {
          val = this.filterVal[singName] + val;
          name = name.replace('Filter', '');
        } else {
          return;
        }
      }
      // tags handle
      if (name == 'tags') {
        val = JSON.stringify(this.tagFilter);
      }
      this.$store.commit('brand/list/FILTER', {name: name, value: val});
      this.GET_ALL({th: this});
      this.updateExportURL()
    },
    // initFilter: function () {
    //   this.siteFilter = this.$store.getters.SITE_FILTER;
    // }
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - 320) / 24.5);
      this.$store.commit('brand/list/PAGE_SIZE', winHeight);
    },
    exportBrand: function (type) {
      this.$store.dispatch('brand/list/DO_EXPORT', {type: type});
      return false;
    },
    prepareName: function (name) {
      name = name.replace(' ', '&nbsp;');
      return name
    },
    rowClass: function (item, type) {
      if (!item || type !== 'row') return
      if (item.isPublished === false) return 'table-danger'
    }
  },
  computed: {
    ...mapGetters([
      'BRAND_LIST',
      'TAG_LIST',
      'IS_SEND_ALREADY',
      'FIELD_FULL_LIST',
      'ACTIVE_FIELD',
      'SELECTED_FIELD',
      'FILTER',
    ]),
    ...mapGetters(['AMOUNT_PAGE']),
    ...mapGetters(['COUNT_ROW']),

    ...mapGetters(['CURRENT_SORT']),
    ...mapGetters(['CURRENT_SORT_DIR']),
    ...mapGetters(['PAGE_SIZE']),
    ...mapGetters(['CURRENT_PAGE']),
    ...mapGetters(['SITE_FILTER']),
    ...mapGetters(['NAME_FILTER']),

    ...mapGetters(['EXPORT_MIN_URL']),
    ...mapGetters(['EXPORT_MAX_URL']),
    ...mapGetters(['EXPORT_URL_FILTER'])
  },
  watch: {
    activeField(newVal) {
      this.$store.commit('brand/list/ACTIVE_FIELD', newVal);
    },
    selectedField(newVal) {
      this.$store.commit('brand/list/SELECTED_FIELD', newVal);
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }

    this.FINANCE_PREPARE();
    this.selectedField = this.SELECTED_FIELD;
    this.activeField = this.ACTIVE_FIELD;
    this.updateAvailableField();
    this.updateExportURL()
  },
  created() {
    if (!this.IS_SEND_ALREADY) {
      this.updateAvailableField();
      this.initPageSize();
      this.GET_ALL({th: this});
      this.GET_TAGS({th: this});
      this.$store.commit('brand/list/IS_SEND_ALREADY', true);
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.filters-tr input[type=text] {
  text-align: center;
}

.total {
  float: left;
  padding-right: 30px;
  padding-top: 7px;
}

.export-nav span {
  padding-right: 30px;
}

.brand-list .datepicker {
  height: 31px !important;
}

.export-nav {
  float: right;
  padding-top: 7px;
}

.brand-list .cell-name {
  overflow: hidden;
  height: 23px;
}

.brand-list select.form-control {
  padding: 2px;
}

.multiselect-relative {
  height: 62px;
  width: 125px;
  position: relative;
}

.multiselect {
  max-width: 125px;
  max-height: 60px;
  position: absolute;
  top: -1px;
}

.brand-list .cell-box {
  overflow: hidden;
  display: block;
  height: 26px;
  padding-left: 3px;
  padding-right: 3px;
  max-width: 150px;
}

.brand-list .cell-box.cell-box-name {
  width: 300px;
  max-width: 300px;
}

.select-field-dummy {
  height: 31px;
}
</style>

<style>
.brand-list .table thead th {
  vertical-align: top;
}

.brand-list .multiselect__single {
  font-size: 13px;
}
</style>